'use strict'

import http from './http-common'
import authHeader from './auth-header'

const getAll = (companyId) => {
  return http.axiosClient.get(`/troubletickets?companyId=${companyId}`, {
    headers: authHeader()
  })
}

const getByCustomer = (companyId, customerId) => {
  return http.axiosClient.get(`/troubletickets?companyId=${companyId}&customerId=${customerId}`, {
    headers: authHeader()
  })
}

const getByOrder = (companyId, orderId) => {
  return http.axiosClient.get(`/troubletickets?companyId=${companyId}&orderId=${orderId}`, {
    headers: authHeader()
  })
}

const get = (id) => {
  return http.axiosClient.get(`/troubletickets/${id}`, { headers: authHeader() })
}

const create = (data) => {
  return http.axiosClient.post('/troubletickets', data, { headers: authHeader() })
}

const update = (id, data) => {
  return http.axiosClient.put(`/troubletickets/${id}`, data, { headers: authHeader() })
}

const remove = (id) => {
  return http.axiosClient.delete(`/troubletickets/${id}`, { headers: authHeader() })
}

const markRead = (troubleTicketsId) => {
  const url = `/troubletickets/read/${troubleTicketsId}`
  return http.axiosClient.post(url, {}, {
    headers: authHeader()
  })
}

export default {
  getAll,
  get,
  create,
  update,
  remove,
  getByCustomer,
  getByOrder,
  markRead
}
